import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Link } from 'react-router';

const DentalFAQ = ({faqs}) => {
  const [openQuestion, setOpenQuestion] = useState('dentalfaq1');

  const toggleQuestion = (id) => {
    setOpenQuestion(openQuestion === id ? null : id);
  };

  return (
    <div className="relative mx-auto px-4 sm:px-6 lg:px-8 xl:px-20 py-16 bg-gradient-to-br from-white via-teal-50 to-lime-50">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          {/* Curved line in top right */}
          <path 
            d="M600,0 C750,50 850,150 950,100" 
            fill="none" 
            stroke="#0AB" 
            strokeWidth="3" 
            strokeOpacity="0.07" 
          />
          
          {/* Curved line in bottom left */}
          <path 
            d="M0,300 C150,350 250,250 350,300" 
            fill="none" 
            stroke="#8D2" 
            strokeWidth="3" 
            strokeOpacity="0.07" 
          />
          
          {/* Small tooth-inspired shape */}
          <path 
            d="M100,100 C120,70 140,90 130,120 C120,150 110,150 100,120 C90,90 80,70 100,100" 
            fill="#0AB" 
            fillOpacity="0.03" 
          />
        </svg>
      </div>
      
      {/* Content */}
      <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-12">
        {/* Title Section */}
        <div className="flex flex-col justify-center">
          <h2 className="text-4xl font-medium text-teal-700 mb-4">
            Frequently Asked <span className="text-lime-600">Questions</span>
          </h2>
          <p className="text-gray-700 max-w-md">
            We've compiled answers to questions our patients ask most frequently. If you don't find what you're looking for, please contact our office – we're here to help!
          </p>
          
          {/* Decorative Element */}
          <div className="hidden lg:block mt-8">
            <svg width="200" height="120" viewBox="0 0 200 120" xmlns="http://www.w3.org/2000/svg">
              <path 
                d="M40,30 C60,10 100,30 60,60 C20,30 40,10 40,30" 
                fill="none" 
                stroke="#0AB" 
                strokeWidth="2"
                className="opacity-30" 
              />
              <path 
                d="M40,40 C50,30 70,40 50,60 C30,40 40,30 40,40" 
                fill="none" 
                stroke="#8D2" 
                strokeWidth="2"
                className="opacity-30" 
              />
              <circle cx="40" cy="30" r="2" fill="#0AB" className="opacity-50" />
              <path 
                d="M40,45 C45,40 50,45 40,55 C30,45 35,40 40,45" 
                fill="#8D2" 
                className="opacity-30" 
              />
            </svg>
          </div>
        </div>

        {/* FAQ List Section */}
        <div className="space-y-4 bg-white/70 backdrop-blur-sm p-6 rounded-lg shadow-sm">
          {faqs.map((faq, idx) => (
            <div 
              key={`dentalfaq${idx+1}`}
              className={`border rounded-lg transition-colors duration-300 ${
                openQuestion === `dentalfaq${idx+1}` 
                  ? 'border-teal-200 bg-teal-50' 
                  : 'border-gray-200 hover:border-teal-100'
              }`}
            >
              <button
                className="w-full px-6 py-4 text-left flex justify-between items-center"
                onClick={() => toggleQuestion(`dentalfaq${idx+1}`)}
              >
                <span className={`text-lg font-medium ${
                  openQuestion === `dentalfaq${idx+1}` 
                    ? 'text-teal-700' 
                    : 'text-gray-700'
                }`}>
                  {faq.question}
                </span>
                <ChevronDown 
                  className={`w-5 h-5 transition-all duration-300 ${
                    openQuestion === `dentalfaq${idx+1}` 
                      ? 'text-lime-500 transform rotate-180' 
                      : 'text-teal-400'
                  }`}
                />
              </button>
              
              <div className={`overflow-hidden transition-all duration-300 ${
                openQuestion === `dentalfaq${idx+1}` ? 'max-h-40' : 'max-h-0'
              }`}>
                <div className="px-6 pb-4">
                  <p className="text-gray-600">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
          
          {/* Contact CTA */}
          <div className="mt-8 pt-4 border-t border-teal-100">
            <p className="text-gray-700 mb-3">
              Still have questions? We're here to help.
            </p>
            <Link
              to='https://wa.me/+918401749379'
              target='_blank' 
              className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white rounded-md transition-colors duration-300 shadow-sm">
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DentalFAQ;